import {withStyles} from "@material-ui/core/styles";
import {Chip} from "@material-ui/core";

const AutocompleteChip = withStyles({
    root: {
        cursor: 'pointer',
        '& .MuiChip-deleteIcon': {
            color: "#fff",
            display: "none",
        }
    }
})(Chip);

export default AutocompleteChip;
